import { Spinner } from "react-bootstrap";

export function LoadingComponent(props) {
	return <div className="mt-4">Loading... <Spinner animation="border" size="sm" className="ms-4" /></div>;
}